module.exports = __webpack_public_path__ + "static/media/diploma.600d4354.ttf";